import { HelmetProvider } from 'react-helmet-async'
import { AuthProvider } from './AuthContext'
import { SettingsProvider } from './SettingsContext'
import { CartProvider } from './CartContext'
import { WishlistProvider } from './WishlistContext'
import { SearchProvider } from './SearchContext'

/**
 * Single root that composes every provider in the right order. Anyone adding
 * a new global provider should add it here, not in main.jsx, so the wrapping
 * order stays in one place.
 *
 * Order matters: AuthProvider sits above Cart/Wishlist so future per-user
 * cart syncing can read from useAuth(), and SettingsProvider sits above
 * CartProvider because the cart prices delivery from useSettings().
 */
export function AppProviders({ children }) {
  return (
    <HelmetProvider>
      <AuthProvider>
        <SettingsProvider>
          <CartProvider>
            <WishlistProvider>
              <SearchProvider>{children}</SearchProvider>
            </WishlistProvider>
          </CartProvider>
        </SettingsProvider>
      </AuthProvider>
    </HelmetProvider>
  )
}
